import { createFileRoute } from "@tanstack/react-router";
import { COMPANY } from "@/lib/company";
import { PROMOTION, promotionEndLong } from "@/lib/promotion";

export const Route = createFileRoute("/actievoorwaarden")({
  head: () => ({
    meta: [
      { title: `Actievoorwaarden — ${COMPANY.name}` },
      {
        name: "description",
        content:
          "Actievoorwaarden voor de acties en aanbiedingen van Elvion Group. Bekijk de geldigheid, voorwaarden en beperkingen.",
      },
      {
        property: "og:title",
        content: `Actievoorwaarden — ${COMPANY.name}`,
      },
      {
        property: "og:description",
        content:
          "Actievoorwaarden voor de acties en aanbiedingen van Elvion Group.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ActievoorwaardenPage,
});

function ActievoorwaardenPage() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:py-20">
      <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
        Actievoorwaarden
      </h1>
      <p className="mt-4 text-text-secondary">
        Op deze pagina vindt u de actievoorwaarden die van toepassing zijn op
        lopende acties en aanbiedingen van {COMPANY.name}.
      </p>

      <section className="mt-10 space-y-6 rounded-2xl border border-border bg-surface px-6 py-8 sm:px-8">
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            {PROMOTION.title}
          </h2>
          <p className="mt-2 text-text-secondary">
            <strong className="text-foreground">Geldig tot:</strong>{" "}
            {promotionEndLong()}
          </p>
        </div>

        <ul className="list-disc space-y-3 pl-5 text-text-secondary">
          {PROMOTION.terms.map((term) => (
            <li key={term}>{term}</li>
          ))}
        </ul>
      </section>

      <p className="mt-8 text-sm text-text-secondary">
        Laatst bijgewerkt: {new Date().toLocaleDateString("nl-NL")}
      </p>
    </main>
  );
}
